import HttpClient from "@/services/HttpClient";
import StoreService from "@/store";
import { EServices } from "@/types";
import IJsonResponse from "@/utils/types/IJsonResponse";
import { inject, injectable } from "tsyringe";
import { IAccountClient } from "../types";

@injectable()
export default class AccountClient implements IAccountClient {
  constructor(
    @inject(EServices.http) private http: HttpClient,
    @inject(EServices.store) private store: StoreService
  ) {}

  async changePassword(
    oldPassword: string,
    newPassword: string
  ): Promise<IJsonResponse> {
    return await this.http.patch("/v1/auth/account/password", {
      oldPassword,
      newPassword,
    });
  }

  async updateAccount(
    firstName: string,
    lastName: string
  ): Promise<IJsonResponse> {
    const response = await this.http.patch("/v1/auth/account", {
      firstName,
      lastName,
    });

    this.store.commit("AccountModule/setAccount", response.data);

    return response;
  }

  async updateCustomer(phone: string, id: number): Promise<IJsonResponse> {
    const response = await this.http.patch("/v1/app/customers/" + id, {
      phone,
    });

    this.store.commit("AccountModule/setCustomer", response.data);

    return response;
  }

  async deleteCustomer(password: string): Promise<IJsonResponse> {
    const response = await this.http.delete("/v1/auth/account/" + password);
    if (response.status === 200) {
      this.store.commit("AccountModule/clear");
      localStorage.clear();
    }
    return response;
  }
}
